import axios from './axios'
import { getLocalStorage } from '@/utils/tools.js'
export function getAllMailList (options) {
  let headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getLocalStorage('token')
    }
  };
  return axios.get("/api/v1/web/letter/get_all_mail", options, headers);
}

export function readTheMail (options) {
  let headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getLocalStorage('token')
    }
  };
  return axios.get('/api/v1/web/letter/read_mail?id=' + options.id, headers);
}

export function getPayMail (options) {
  let headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getLocalStorage('token')
    }
  };
  return axios.get('/api/v1/web/letter/get_pay_index?id=' + options.id, headers)
}

export function getPayType (options) {
  let headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getLocalStorage('token')
    }
  };
  return axios.get('/api/v1/web/letter/get_pay_type?id=' + options.id, headers)
}